import {
  arrayBuilderYesNoSchema,
  arrayBuilderYesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { formatFullName } from 'platform/shared/health-apps';
import ApplicantSummaryCard from '../../components/FormDescriptions/ApplicantSummaryCard';
import { APPLICANTS_MAX } from '../../utils/constants';

const yesNoOptions = { labelHeaderLevel: '' };

export const applicantOptions = {
  arrayPath: 'applicants',
  nounSingular: 'applicant',
  nounPlural: 'applicants',
  required: true,
  maxItems: APPLICANTS_MAX,
  text: {
    getItemName: item => formatFullName(item.applicantName),
    cardDescription: ApplicantSummaryCard,
  },
};

export default {
  uiSchema: {
    'view:hasApplicants': arrayBuilderYesNoUI(
      applicantOptions,
      yesNoOptions,
      yesNoOptions,
    ),
  },
  schema: {
    type: 'object',
    required: ['view:hasApplicants'],
    properties: {
      'view:hasApplicants': arrayBuilderYesNoSchema,
    },
  },
};
